module.exports = __webpack_public_path__ + "img/upgrade-img-5.758da368.png";